module.exports = __webpack_public_path__ + "img/bg-card-frecuente@2x.66b6067e.png";